import { Component, EventEmitter, input, Input, Output } from '@angular/core';
import { MapLayerInfo } from '@app/models/data-types/map-layer-info';
import { LegendComponent } from './legend/legend.component';
import { SelectComponent } from '@app/components/input/select/select.component';
import { InfoButtonComponent } from '@app/components/info-modal/info-button/info-button.component';
import { DoubleValueLabelPair } from '@app/models/data-types/double-value-label-pair';
import { WmsLayer } from '@app/models/map/WmsLayer';

@Component({
	selector: 'app-layer-selector',
	standalone: true,
	imports: [LegendComponent, SelectComponent, InfoButtonComponent],
	templateUrl: './layer-selector.component.html',
	styleUrl: './layer-selector.component.css',
})
export class LayerSelectorComponent {
	@Input() layers: WmsLayer[] = [];
	@Input() selectedLayer: WmsLayer = {} as WmsLayer;
	@Input() showModal: boolean = true;
	@Input() modalId: string = '';
	@Input() selectElementId: string = '';
	@Input() selectLabel: string = '';

	@Output() layerSelected = new EventEmitter<string>();

	/**
	 * converts layer objects to options that can be rebdered in selects
	 * @returns
	 */
	getLayersAsOptions() {
		let options: DoubleValueLabelPair[] = [];

		for (const layer of this.layers) {
			options.push({
				secondaryValue: layer.name,
				primaryValue: layer.name,
				label: layer.name,
			});
		}

		return options;
	}

	onSelectOption(name: string) {
		this.layerSelected.emit(name);
	}
}
